<template>



    <div class="modal modal-active">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">{{_lang('Unpublish project')}}</div>
             <span class="close" @click="close">&times;</span>
          </div>
           <div class="modal-body">
               <div class="form-group">
                <dl>
                    <dt>{{_lang('Domain')}}</dt>
                    <dd>{{project.domain}}</dd>
                </dl>
               </div>

                <div class="mt-2">
                    <button v-if="!isProcessing && !done" class="btn btn-danger" @click="unpublish">{{_lang('Unublish')}}</button>
                </div>

                    <div v-if="isProcessing">
                      <progress />
                    </div>

                    <div class="form-group mt-2" v-if="response">
                        <label>{{_lang('Response')}}:</label>
                        <div class="alert alert-info">{{response}}</div>
                    </div>


           </div>
         </div>
       </div>
    </div>


</template>

<script>
import axios from 'axios';
export default {
    props:['project','active'],

    data(){
        return {
						response:'',
						done:false,
            isProcessing:false,
        }
    },
    methods:{

        close(){
            this.$emit('close');
        },
    unpublish(){

      this.response = '';

      this.isProcessing = true;

      axios({
        method: 'post',
        url: '/api/unpublish/'+this.project.id,
      }).then((res) => {
        this.response = res.data;
				this.isProcessing = false;
				this.done = true;
				this.$emit('update');
      }).catch(err=>{
        this.isProcessing = false;
        this.response = JSON.stringify(err.response);
      });



    },

    },


}
</script>

<style scoped>

</style>
